/**
 * Takes any data object and recursively retrieves any column name with a matching _l10n column
 * Returns an array of column names
 *
 * Example:
 *
 * getColumnNamesHavingL10nSuffix(
 *  {
 *    name: 'name EN',
 *    name_l10n: {
 *      'en-US': 'name EN',
 *       'fr-FR': 'name FR'
 *    },
 *    nestedThing: [
 *      {
 *        columnName: 'thing EN',
 *        columnName_l10n: {
 *          'en-US': 'thing EN'
 *          'fr-FR': 'thing FR'
 *        }
 *      }
 *    ]
 *  })
 *
 * returns:
 *  ["name", "nestedThing[0].columnName"]
 */

export function getColumnNamesHavingL10nSuffix(obj: any): string[] {
  const visited = new WeakSet();

  function processNode(node: any, path = ''): string[] {
    if (!node || typeof node !== 'object' || visited.has(node)) {
      return [];
    }

    visited.add(node);

    if (Array.isArray(node)) {
      return node.flatMap((item, index) =>
        processNode(item, path ? `${path}[${index}]` : `[${index}]`)
      );
    }

    return Object.entries(node).flatMap(([key, value]) => {
      const currentPath = path ? `${path}.${key}` : key;

      if (key.endsWith('_l10n')) {
        const primaryKey = key.replace('_l10n', '');
        const primaryPath = path ? `${path}.${primaryKey}` : primaryKey;

        return [primaryPath];
      }

      if (typeof value === 'object' && value !== null) {
        return processNode(value, currentPath);
      }

      return [];
    });
  }

  return processNode(obj);
}
